import { useEffect, useState } from 'react';

import type { ReasonModel } from '@/domain/models/reason.js';
import type { ReasonController } from '@/presentation/controllers/reason-controller.js';
import type { ReasonCategory } from '@/shared/utils/format-status.js';

export function useReasonOptions(reasonController: ReasonController, category: ReasonCategory, enabled: boolean): ReasonModel[] {
    const [reasons, setReasons] = useState<ReasonModel[]>([]);

    useEffect(() => {
        if (!enabled) {
            // Idempotente de propósito: `setReasons([])` alocaria um array novo a cada execução, o React
            // não faria bail-out e um caller com `reasonController` instável entraria em loop de render.
            setReasons((current) => (current.length === 0 ? current : []));
            return;
        }
        let cancelled = false;
        reasonController
            .loadReasons({ category, isActive: true })
            .then((result) => {
                if (cancelled) {
                    return;
                }
                result.fold(
                    () => setReasons([]),
                    (loaded) => setReasons(loaded)
                );
            })
            .catch(() => {
                if (!cancelled) {
                    setReasons([]);
                }
            });
        return () => {
            cancelled = true;
        };
    }, [reasonController, category, enabled]);

    return reasons;
}
